import React from 'react';
import UseData from '../../Hooks/UseData';
import Footer from '../../Share/Footer';
import PageTitle from '../../Share/PageTitle';
import LineItem from './LineItem';
import ResumeCard from './ResumeCard';
import logo from '../../assets/images/logo/logo-red-blue.png';

const ResumeTwo = () => {
  const { lineArray, resumeArray } = UseData();
  return (
    <>
      <PageTitle title='CV'></PageTitle>
      {/* End pagetitle */}

      <section className='bg-white  lg:rounded-2xl dark:bg-[#111111]'>
        <div data-aos='fade'>
          <div className='container sm:px-5 md:px-10 lg:px-14'>
            <div className='py-12 px-4 md:px-0'>
              {/*Resume page title */}
              <h2 className='after-effect after:left-60'>Curriculum</h2>
              <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-x-6 gap-y-6 mt-[30px]'>
                {resumeArray.map((category, categoryIndex) => {
                  const elements = category.elements.map((item, index) => {
                    const icon = index === 0 ? category.icon : false;
                    const key = `${categoryIndex}-${index}`;
                    item.type = category.type;
                    item.icon = icon;
                    return <ResumeCard item={item} key={key} />;
                  });
                  const catKey = `cat-${categoryIndex}`;
                  return <div key={catKey}>{elements}</div>;
                })}
              </div>
            </div>
          </div>
          {/* End .container */}

          <div className='container bg-color-810 dark:bg-[#0D0D0D] py-12 px-2 sm:px-5 md:px-10 lg:px-20'>
            <div className='grid grid-cols-1  md:grid-cols-2 gap-8'>
              <div className='col-span-2 float text-center flex flex-col items-center'>
                <img
                  className='h-[72px] lg:h-[140px] mx-auto'
                  src={logo}
                  alt='logo'
                />
                <span className='text-sm lg:text-xl font-bold text-[#44566C] dark:text-[#A6A6A6] mt-1 uppercase tracking-widest'>
                  Studio tecnico
                </span>
                {/* <h4 className="text-5xl dark:text-white font-medium mb-6">
                  Working Skills
                </h4> */}
                {/* Experience percent element */}
                {/* {lineArray.map((item, i) => (
                  <LineItem item={item} key={i} />
                ))} */}
              </div>

              {/* knowledge section start */}
              {/* 
              <div className="col-span-1">
                <h4 className="text-5xl dark:text-white font-medium mb-8">
                  Knowledges
                </h4>


                <div className="flex gap-y-5 gap-x-2.5 flex-wrap">
                  <button className="resume-btn">Digital Design</button>
                  <button className="resume-btn">Marketing</button>
                  <button className="resume-btn">Social Media</button>
                  <button className="resume-btn">Print</button>
                  <button className="resume-btn">Time Management</button>
                  <button className="resume-btn">Flexibility</button>
                  <button className="resume-btn">Print</button>
                </div>
              </div> */}

              {/* knowledge section end */}
            </div>
          </div>
          {/* End .container */}

          <Footer condition={false} bg={'#FFFF'} />
        </div>
      </section>
    </>
  );
};

export default ResumeTwo;
